(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
// Initialize cart API immediately
window.cartAPI = {
  cartDrawer: null,
  cartPanel: null,
  cartContent: null,
  cartSubtotal: null,
  
  init() {
    this.cartDrawer = document.getElementById('cart-drawer');
    this.cartPanel = this.cartDrawer?.querySelector('[data-cart-panel]');
    this.cartContent = this.cartDrawer?.querySelector('[data-cart-content]');
    this.cartSubtotal = this.cartDrawer?.querySelector('[data-cart-subtotal]');
    
    if (!this.cartDrawer || !this.cartPanel) {
      return false;
    }
    
    // Initialize checkout button
    const checkoutButton = this.cartDrawer.querySelector('[data-checkout-button]');
    if (checkoutButton) {
      checkoutButton.addEventListener('click', (e) => this.handleCheckout(e));
    }
    
    this.attachEventListeners();
    return true;
  },

  async handleCheckout(event) {
    event.preventDefault();
    
    try {
      // Verify cart has items
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      if (!cart.item_count) {
        return false;
      }

      // Show loading state
      const checkoutButton = event.target.closest('[data-checkout-button]');
      if (checkoutButton) {
        checkoutButton.textContent = 'Processing...';
      }

      // Redirect to checkout
      window.location.href = '/checkout';
      return false;
    } catch (error) {
      return false;
    }
  },

  async open() {
    // Try to initialize if not already done
    if (!this.cartDrawer) {
      if (!this.init()) {
        return;
      }
    }
    
    try {
      // Fetch updated cart content
      const response = await fetch('/?section_id=cart-drawer');
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newContent = doc.querySelector('[data-cart-content]');
      const newSubtotal = doc.querySelector('[data-cart-subtotal]');

      if (newContent && this.cartContent) {
        this.cartContent.innerHTML = newContent.innerHTML;
      }
      if (newSubtotal && this.cartSubtotal) {
        this.cartSubtotal.innerHTML = newSubtotal.innerHTML;
      }

      // Show drawer
      this.cartDrawer.classList.remove('invisible', 'opacity-0');
      this.cartPanel.classList.remove('translate-x-full');
      document.body.style.overflow = 'hidden';
      
      // Reattach event listeners
      this.attachEventListeners();
      // Update UI globally
      updateCartUI();
      // Add this function to update checkout button state
      updateCheckoutButtonState();
    } catch (error) {
    }
  },

  close() {
    if (!this.cartDrawer) return;
    
    this.cartDrawer.classList.add('opacity-0');
    this.cartPanel.classList.add('translate-x-full');
    document.body.style.overflow = '';
    setTimeout(() => {
      this.cartDrawer.classList.add('invisible');
    }, 500);
  },

  attachEventListeners() {
    if (!this.cartDrawer) return;

    // Close cart when clicking overlay or close button
    const closeElements = this.cartDrawer.querySelectorAll('[data-cart-close], [data-cart-overlay]');
    closeElements.forEach(element => {
      element.addEventListener('click', () => this.close());
    });

    // Handle quantity changes and removals
    this.cartDrawer.addEventListener('click', async (e) => {
      const decreaseBtn = e.target.closest('[data-quantity-decrease]');
      const increaseBtn = e.target.closest('[data-quantity-increase]');
      const removeBtn = e.target.closest('[data-remove-item]');

      if (!decreaseBtn && !increaseBtn && !removeBtn) return;

      const key = decreaseBtn?.dataset.quantityDecrease || 
                 increaseBtn?.dataset.quantityIncrease || 
                 removeBtn?.dataset.removeItem;
      
      let quantity = 0;
      
      if (decreaseBtn) {
        const currentQty = parseInt(decreaseBtn.nextElementSibling.textContent);
        quantity = Math.max(0, currentQty - 1);
      } else if (increaseBtn) {
        const currentQty = parseInt(increaseBtn.previousElementSibling.textContent);
        quantity = currentQty + 1;
      }

      try {
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: key,
            quantity: quantity
          })
        });

        if (!response.ok) throw new Error('Cart update failed');

        const cartData = await response.json();
        
        // Update cart counts
        const cartCountElements = document.querySelectorAll('[data-cart-count]');
        cartCountElements.forEach(element => {
          element.textContent = cartData.item_count;
          element.style.display = cartData.item_count > 0 ? 'flex' : 'none';
        });

        // Refresh cart content
        await this.open();
        // Update UI globally
        updateCartUI();

      } catch (error) {
      }
    });
  },

  async removeButtons(itemKey) {
    try {
      // Get the current item from the cart
      const response = await fetch('/cart.js');
      const cart = await response.json();
      const item = cart.items.find(i => i.key === itemKey);
      
      if (!item) {
        return;
      }
      
      // Update the item to remove buttons
      const properties = { ...item.properties };
      delete properties['_Add Buttons'];
      
      const updateResponse = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: itemKey,
          quantity: item.quantity,
          properties: properties
        })
      });

      if (!updateResponse.ok) {
        throw new Error('Failed to update item');
      }

      // Remove the button product if it exists
      const buttonItem = cart.items.find(i => 
        i.properties && i.properties['_Parent Product'] === item.product_title
      );

      if (buttonItem) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: buttonItem.key,
            quantity: 0
          })
        });
      }

      // Refresh the cart
      await this.open();
      // Update UI globally
      updateCartUI();

    } catch (error) {
      alert('Failed to remove buttons. Please try again.');
    }
  }
};

// Initialize cart API when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  window.cartAPI.init();
});

// Handle cart:open event
window.addEventListener('cart:open', () => {
  window.cartAPI.open();
});

// Define the close notes function in global scope
window.closeNotesExpansion = function(itemKey) {
  const notesFullElement = document.getElementById('notes-full-' + itemKey);
  const notesBtnElement = document.getElementById('notes-btn-' + itemKey);
  
  if (notesFullElement && !notesFullElement.classList.contains('hidden')) {
    notesFullElement.classList.add('hidden');
    notesBtnElement.classList.remove('hidden');
  }
};

// Add this function to update cart count in the header
function updateCartCount(itemCount) {
  const cartCountElements = document.querySelectorAll('[data-cart-count]');
  cartCountElements.forEach(element => {
    element.textContent = itemCount;
    element.style.display = itemCount > 0 ? 'flex' : 'none';
  });
}

// Update both checkout button and cart count after cart updates
function updateCartUI() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      updateCheckoutButtonState(cart.item_count);
      updateCartCount(cart.item_count);
    });
}

// Modify updateCheckoutButtonState to accept itemCount
function updateCheckoutButtonState(itemCount) {
  const checkoutButton = document.querySelector('[data-checkout-button]');
  if (checkoutButton) {
    if (itemCount > 0) {
      checkoutButton.classList.remove('opacity-50', 'pointer-events-none');
    } else {
      checkoutButton.classList.add('opacity-50', 'pointer-events-none');
    }
  }
}

// Call updateCartUI after cart content is updated (after open, after quantity change, after remove)
updateCartUI();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-grid"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Filter toggle
  const urlParams_ = window.location.href;
  
  // Extract filter parameters from URL
  const filterTrigger = document.querySelector('[data-filter-trigger]');
  const urlParams = new URLSearchParams(window.location.search);
  
  // Get all filter parameters - support multiple values for the same filter
  const filterParams = [];
  const activeFilters = {};

  // Get all parameter keys
  const paramKeys = Array.from(new Set(urlParams.keys()));
  
  // Process parameters, handling multiple values for the same key
  paramKeys.forEach(key => {
    if (key.startsWith('filter.')) {
      // Get all values for this key (handles multiple selections)
      const values = urlParams.getAll(key);
      
      // Extract the filter name from the key (e.g., "product_type" from "filter.p.product_type")
      const filterName = key.split('filter.')[1];
      
      if (filterName) {
        // Format option filters specially (remove "option." prefix)
        const displayName = filterName.startsWith('option.') 
          ? filterName.replace('option.', '') 
          : filterName;
        
        // Add each value to filters array
        values.forEach(value => {
          filterParams.push(`${displayName}: ${decodeURIComponent(value)}`);
        });

        // Store in activeFilters object for checkbox updates
        if (!activeFilters[filterName]) {
          activeFilters[filterName] = [];
        }
        
        // Add all values to the array
        values.forEach(value => {
          activeFilters[filterName].push(decodeURIComponent(value));
        });
      }
    }
  });
  
  // Update filter button text with active filters
  if (filterParams.length > 0 && filterTrigger) {
    filterTrigger.innerHTML = `Filter: (${filterParams.length})`;
    
    // Auto-open the filter panel if filters are active
    const filterCheckbox = document.getElementById('facets-form-toggle-checkbox');
    if (filterCheckbox) {
      filterCheckbox.checked = true;
      const filterContainer = document.querySelector('[data-filter-container]');
      if (filterContainer) {
        filterContainer.style.transform = 'translateX(0)';
      }
    }
  }

  // Check filter checkboxes based on URL parameters
  const updateFilterCheckboxes = () => {
    // Handle product type filters
    if (activeFilters['product_type']) {
      const productTypeValues = activeFilters['product_type'];
      productTypeValues.forEach(value => {
        const productTypeCheckbox = document.querySelector(`input[type="checkbox"][value="${value}"]`);
        if (productTypeCheckbox) {
          productTypeCheckbox.checked = true;
        }
      });
    }

    // Special handling for length option
    if (activeFilters['option.length']) {
      const lengthValues = activeFilters['option.length'];
      
      lengthValues.forEach(lengthValue => {
        // First try with exact value
        let lengthCheckbox = document.querySelector(`input[type="checkbox"][value="${lengthValue}"]`);
        
        // If not found, try with data-filter-name
        if (!lengthCheckbox) {
          lengthCheckbox = document.querySelector(`input[type="checkbox"][data-filter-name="length"][value="${lengthValue}"]`);
        }
        
        // If still not found, try finding by the value content (when value is a number)
        if (!lengthCheckbox) {
          document.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
            if (checkbox.value === lengthValue || checkbox.value === `${lengthValue}`) {
              lengthCheckbox = checkbox;
            }
          });
        }
        
        if (lengthCheckbox) {
          lengthCheckbox.checked = true;
          // Ensure the parent section is visible
          const parentSection = lengthCheckbox.closest('[data-filter-content]');
          if (parentSection) {
            parentSection.classList.remove('hidden');
            
            // Find and check the corresponding radio button
            const sectionId = parentSection.getAttribute('data-filter-content');
            const radio = document.getElementById(`filter-${sectionId}`);
            if (radio) {
              radio.checked = true;
            }
          }
        }
      });
    }

    // Special handling for chest size option
    if (activeFilters['option.size'] || activeFilters['option.chest_size']) {
      const sizeKey = activeFilters['option.size'] ? 'option.size' : 'option.chest_size';
      const sizeValues = activeFilters[sizeKey];
      
      sizeValues.forEach(sizeValue => {
        // Try multiple selectors to find the right checkbox
        let sizeCheckbox = document.querySelector(`input[type="checkbox"][value="${sizeValue}"]`);
        
        if (!sizeCheckbox) {
          sizeCheckbox = document.querySelector(`input[type="checkbox"][data-filter-name="size"][value="${sizeValue}"]`);
        }
        
        if (!sizeCheckbox) {
          sizeCheckbox = document.querySelector(`input[type="checkbox"][data-filter-name="chest_size"][value="${sizeValue}"]`);
        }
        
        // Handle common size values (Small, Medium, Large, etc.)
        if (!sizeCheckbox) {
          const commonSizes = ['Small', 'Medium', 'Large', 'XL', 'XXL'];
          commonSizes.forEach(size => {
            if (sizeValue.toLowerCase() === size.toLowerCase()) {
              const possibleCheckbox = document.querySelector(`input[type="checkbox"][value="${size}"]`);
              if (possibleCheckbox) {
                sizeCheckbox = possibleCheckbox;
              }
            }
          });
        }
        
        if (sizeCheckbox) {
          sizeCheckbox.checked = true;
          // Ensure the parent section is visible
          const parentSection = sizeCheckbox.closest('[data-filter-content]');
          if (parentSection) {
            parentSection.classList.remove('hidden');
            
            // Find and check the corresponding radio button
            const sectionId = parentSection.getAttribute('data-filter-content');
            const radio = document.getElementById(`filter-${sectionId}`);
            if (radio) {
              radio.checked = true;
            }
          }
        }
      });
    }

    // Handle option filters (other than length and size)
    Object.keys(activeFilters).forEach(key => {
      if (key.startsWith('option.') && 
          key !== 'option.length' && 
          key !== 'option.size' && 
          key !== 'option.chest_size') {
        
        const optionName = key.replace('option.', '');
        const optionValues = activeFilters[key];
        
        optionValues.forEach(optionValue => {
          // Find and check the corresponding checkbox
          const optionCheckbox = document.querySelector(`input[type="checkbox"][data-filter-name="${optionName}"][value="${optionValue}"]`);
          if (optionCheckbox) {
            optionCheckbox.checked = true;
            
            // Ensure the parent section is visible
            const parentSection = optionCheckbox.closest('[data-filter-content]');
            if (parentSection) {
              parentSection.classList.remove('hidden');
              
              // Find and check the corresponding radio button
              const sectionId = parentSection.getAttribute('data-filter-content');
              const radio = document.getElementById(`filter-${sectionId}`);
              if (radio) {
                radio.checked = true;
              }
            }
          }
        });
      }
    });
  };

  // Run after a short delay to ensure DOM is fully loaded
  setTimeout(updateFilterCheckboxes, 100);
  
  const filterCheckbox = document.getElementById('facets-form-toggle-checkbox');
  const filterContainer = document.querySelector('[data-filter-container]');
  
  if (filterCheckbox) {
    filterCheckbox.addEventListener('change', () => {
    filterContainer.style.transform = filterCheckbox.checked ? 'translateX(0)' : 'translateX(100%)';
    });
  }

  // Sort functionality
  const sortTrigger = document.querySelector('[data-sort-trigger]');
  const sortDropdown = document.querySelector('[data-sort-dropdown]');
  const sortLabel = document.querySelector('[data-sort-label]');
  const sortOptions = document.querySelectorAll('[data-sort-option]');

  // Set initial sort label based on URL parameter
  const currentSort = urlParams.get('sort_by');
  if (sortLabel) {
    let selectedOption;
    
    if (currentSort) {
      // Find option matching the URL sort parameter
      selectedOption = document.querySelector(`[data-sort-option][data-sort-value="${currentSort}"]`);
    } else {
      // Default to 'Featured' if no sort parameter
      selectedOption = document.querySelector('[data-sort-option="manual"]');
    }

    if (selectedOption) {
      sortLabel.textContent = selectedOption.textContent.trim();
      // Add underline to current sort option
      sortOptions.forEach(opt => {
        if (opt === selectedOption) {
          opt.classList.add('underline');
        } else {
          opt.classList.remove('underline');
        }
      });
    }
  }

  if (sortTrigger && sortDropdown) {
    sortTrigger.addEventListener('click', () => {
      sortDropdown.classList.toggle('hidden');
    });

    sortOptions.forEach(option => {
      option.addEventListener('click', () => {
        const value = option.getAttribute('data-sort-value');
        const label = option.textContent.trim();
        sortLabel.textContent = label;
        sortDropdown.classList.add('hidden');
        
        // Update URL with sort parameter
        const url = new URL(window.location.href);
        if (!value) {
          url.searchParams.delete('sort_by');
        } else {
          url.searchParams.set('sort_by', value);
        }
        window.location.href = url.toString();
      });
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', (e) => {
      if (!sortTrigger.contains(e.target)) {
        sortDropdown.classList.add('hidden');
      }
    });
  }

  // Filter category toggles
  const filterToggles = document.querySelectorAll('.facets-bar__popup-toggle-radio');
  filterToggles.forEach(toggle => {
    toggle.addEventListener('change', () => {
      const content = document.querySelector(`[data-filter-content="${toggle.id.replace('filter-', '')}"]`);
      content.classList.toggle('hidden');
    });
  });

  // Load More functionality
  const loadMoreBtn = document.querySelector('[data-load-more]');
  const productsContainer = document.querySelector('[data-products-container]');
  const productsCount = document.querySelector('[data-products-count]');
  
  if (loadMoreBtn) {
    loadMoreBtn.addEventListener('click', async () => {
      const nextUrl = new URL(window.location.href);
      const currentPage = parseInt(nextUrl.searchParams.get('page')) || 1;
      nextUrl.searchParams.set('page', currentPage + 1);
      
      try {
        const response = await fetch(nextUrl);
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        // Get new products
        const newProducts = doc.querySelectorAll('[data-product-card]');
        newProducts.forEach(product => {
          productsContainer.insertBefore(product, loadMoreBtn.parentElement);
        });
        
        // Update products count
        const newCount = doc.querySelector('[data-products-count]');
        if (newCount && productsCount) {
          productsCount.textContent = newCount.textContent;
        }
        
        // Update or remove load more button
        const nextPageExists = doc.querySelector('[data-load-more]');
        if (!nextPageExists) {
          loadMoreBtn.parentElement.remove();
        }
        
        // Update URL
        window.history.pushState({}, '', nextUrl);
      } catch (error) {
      }
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-season"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const grid = document.getElementById('season-grid');
  const overlay = document.getElementById('gallery-overlay');
  const closeBtn = document.getElementById('close-gallery');
  const gridImages = document.querySelectorAll('.product-image-container');
  const galleryImages = document.querySelectorAll('.gallery-image');
  const thumbnails = document.querySelectorAll('.thumbnail-image');
  const galleryContainer = document.querySelector('.gallery-container');
  const thumbnailContainer = document.querySelector('.thumbnail-container');
  
  function showImage(index) {
    const targetImage = galleryImages[index];
    targetImage.scrollIntoView({ behavior: 'smooth', block: 'center' });
    thumbnails.forEach((thumb, i) => {
      thumb.classList.toggle('opacity-50', i !== index);
    });
    
    // Center the active thumbnail in the sidebar
    const activeThumb = thumbnails[index];
    const thumbHeight = activeThumb.offsetHeight;
    const containerHeight = thumbnailContainer.offsetHeight;
    const scrollPosition = (activeThumb.offsetTop + (thumbHeight / 2)) - (containerHeight / 2);
    thumbnailContainer.scrollTo({
      top: scrollPosition,
      behavior: 'smooth'
    });
  }

  // Sync thumbnail selection with scroll position
  let isScrolling;
  galleryContainer.addEventListener('scroll', () => {
    clearTimeout(isScrolling);
    
    isScrolling = setTimeout(() => {
      const galleryRect = galleryContainer.getBoundingClientRect();
      let currentIndex = 0;
      
      galleryImages.forEach((image, index) => {
        const rect = image.getBoundingClientRect();
        const imageCenter = rect.top + (rect.height / 2);
        const viewportCenter = galleryRect.top + (galleryRect.height / 2);
        if (Math.abs(imageCenter - viewportCenter) < rect.height / 2) {
          currentIndex = index;
          // Center the active thumbnail
          const activeThumb = thumbnails[currentIndex];
          const thumbHeight = activeThumb.offsetHeight;
          const containerHeight = thumbnailContainer.offsetHeight;
          const scrollPosition = (activeThumb.offsetTop + (thumbHeight / 2)) - (containerHeight / 2);
          thumbnailContainer.scrollTo({
            top: scrollPosition,
            behavior: 'smooth'
          });
        }
      });
      
      thumbnails.forEach((thumb, i) => {
        thumb.classList.toggle('opacity-50', i !== currentIndex);
      });
    }, 50);
  });

  // Open gallery
  gridImages.forEach(image => {
    image.addEventListener('click', () => {
      const index = parseInt(image.dataset.index);
      overlay.classList.remove('hidden');
      document.body.style.overflow = 'hidden';
      
      showImage(index);
    });
  });

  // Thumbnail click handlers
  thumbnails.forEach(thumb => {
    thumb.addEventListener('click', () => {
      const index = parseInt(thumb.dataset.index);
      showImage(index);
    });
  });

  // Close gallery
  closeBtn.addEventListener('click', () => {
    overlay.classList.add('hidden');
    document.body.style.overflow = '';
  });

  // Close on escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !overlay.classList.contains('hidden')) {
      overlay.classList.add('hidden');
      document.body.style.overflow = '';
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const newsletterForm = document.querySelector('form.relative');
  const successPopup = document.getElementById('newsletter-success');
  
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', async function(e) {
      e.preventDefault();
      
      try {
        const formData = new FormData(this);
        const response = await fetch('/contact', {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: formData
        });
        
        if (response.ok) {
          // Show success popup
          successPopup.style.opacity = '1';
          successPopup.style.transform = 'translate(-50%, 0)';
          
          // Clear form
          this.reset();
          
          // Hide popup after 3 seconds
          setTimeout(() => {
            successPopup.style.opacity = '0';
            successPopup.style.transform = 'translate(-50%, -100%)';
          }, 3000);
        } else {
          throw new Error('Newsletter subscription failed');
        }
      } catch (error) {
        // Show error message
        const errorPopup = document.createElement('div');
        errorPopup.className = 'fixed top-8 left-1/2 -translate-x-1/2 bg-black text-white px-6 py-3 rounded-lg z-[100]';
        errorPopup.innerHTML = '<p class="text-[13px] whitespace-nowrap">Failed to subscribe. Please try again.</p>';
        document.body.appendChild(errorPopup);
        
        setTimeout(() => {
          errorPopup.remove();
        }, 3000);
      }
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    // Cache DOM elements for better performance
    const elements = {
        announcementBar: document.getElementById('announcement-bar'),
        closeAnnouncement: document.getElementById('close-announcement'),
        navbar: document.getElementById('navbar'),
        mobileMenu: document.getElementById('mobile-menu'),
        menuBtn: document.getElementById('mobile-menu-btn'),
        closeBtn: document.getElementById('close-menu-btn'),
        navDropdown: document.getElementById('nav-dropdown'),
        navTriggers: document.querySelectorAll('[data-nav-trigger]'),
        navTabs: document.querySelectorAll('.nav-tab'),
        tabContents: document.querySelectorAll('.tab-content'),
        searchTrigger: document.querySelector('[data-search-trigger]'),
        searchBar: document.getElementById('search-bar')
    };

    // Announcement bar
    if (elements.closeAnnouncement && elements.announcementBar) {
        elements.closeAnnouncement.addEventListener('click', () => {
            elements.announcementBar.style.display = 'none';
        });
    }

    // Mobile menu toggle
    if (elements.menuBtn && elements.mobileMenu) {
        elements.menuBtn.addEventListener('click', () => {
            elements.mobileMenu.classList.remove('-translate-x-full');
            document.body.style.overflow = 'hidden';
        });
    }

    if (elements.closeBtn && elements.mobileMenu) {
        elements.closeBtn.addEventListener('click', () => {
            elements.mobileMenu.classList.add('-translate-x-full');
            document.body.style.overflow = '';
        });
    }

    // Navigation Dropdown Functions
    function openNavDropdown() {
        if (elements.navDropdown) {
            elements.navDropdown.style.opacity = '1';
            elements.navDropdown.style.pointerEvents = 'auto';
            elements.navDropdown.style.visibility = 'visible';
            elements.navDropdown.style.transform = 'translateX(0)';
        }
    }

    function closeNavDropdown() {
        if (elements.navDropdown) {
            elements.navDropdown.style.opacity = '0';
            elements.navDropdown.style.pointerEvents = 'none';
            elements.navDropdown.style.transform = 'translateX(-100%)';
            // Remove active class from all triggers when closing
            elements.navTriggers.forEach(t => t.classList.remove('active'));
            setTimeout(() => {
                if (elements.navDropdown) {
                    elements.navDropdown.style.visibility = 'hidden';
                }
            }, 300);
        }
    }

    // Navigation trigger functionality
    if (elements.navTriggers.length > 0) {
        elements.navTriggers.forEach(trigger => {
            trigger.addEventListener('click', (e) => {
                e.preventDefault();
                const tabTarget = trigger.getAttribute('data-tab-target');
                if (tabTarget) {
                    // Remove active class from all triggers
                    elements.navTriggers.forEach(t => t.classList.remove('active'));
                    
                    // Add active class to clicked trigger
                    trigger.classList.add('active');
                    
                    // Hide all content sections first
                    elements.tabContents.forEach(c => {
                        c.classList.add('hidden');
                        c.style.display = 'none';
                    });
                    
                    // Show the corresponding content
                    const correspondingContent = document.querySelector(`[data-content="${tabTarget}"]`);
                    if (correspondingContent) {
                        correspondingContent.classList.remove('hidden');
                        correspondingContent.style.display = 'block';
                    }
                    
                    // Open dropdown after content is ready
                    openNavDropdown();
                }
            });
        });
    }



    // Close dropdown when clicking outside
    document.addEventListener('click', (e) => {
        if (elements.navDropdown && !elements.navDropdown.contains(e.target) && !e.target.closest('[data-nav-trigger]')) {
            closeNavDropdown();
        }
    });



    // Close dropdown on escape key
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && elements.navDropdown) {
            closeNavDropdown();
        }
    });

    // Search functionality
    function toggleSearch() {
        if (elements.searchBar) {
            const isHidden = elements.searchBar.classList.contains('hidden');
            
            if (isHidden) {
                elements.searchBar.classList.remove('hidden');
                const searchInput = elements.searchBar.querySelector('input');
                if (searchInput) {
                    searchInput.focus();
                }
            } else {
                elements.searchBar.classList.add('hidden');
            }
        }
    }

    // Search trigger event listener
    if (elements.searchTrigger) {
        elements.searchTrigger.addEventListener('click', toggleSearch);
    }

    // Close search when clicking outside
    document.addEventListener('click', (e) => {
        if (elements.searchBar && !elements.searchBar.contains(e.target) &&
            !(elements.searchTrigger && elements.searchTrigger.contains(e.target))) {
            elements.searchBar.classList.add('hidden');
        }
    });

    // Close search on escape key
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && elements.searchBar && !elements.searchBar.classList.contains('hidden')) {
            elements.searchBar.classList.add('hidden');
        }
    });

    /* ----------------------------------------------------------------
     * Live search suggestions
     *
     * Queries Shopify's predictive-search endpoint as the shopper types
     * and renders matches directly beneath the input.
     * ---------------------------------------------------------------- */
    (function initLiveSearch() {
        const form    = document.querySelector('[data-search-form]');
        const input   = document.querySelector('[data-search-input]');
        const panel   = document.querySelector('[data-search-results]');
        const status  = document.querySelector('[data-search-status]');
        if (!form || !input || !panel) return;

        const CURRENCY = form.getAttribute('data-currency') || '';
        const LIMIT = 6;
        const DEBOUNCE_MS = 250;

        let timer = null;
        let controller = null;
        let activeIndex = -1;
        let lastQuery = '';

        // The endpoint returns price as a decimal string in major units
        // (e.g. "1080.00"), not cents -- do not divide by 100.
        function formatPrice(value) {
            const n = parseFloat(value);
            if (!isFinite(n)) return '';
            return CURRENCY + ' ' + n.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        }

        function thumb(url) {
            if (!url) return '';
            // Ask the Shopify CDN for a small render instead of the full image.
            return url.indexOf('?') > -1 ? url + '&width=120' : url + '?width=120';
        }

        function escapeHtml(s) {
            return String(s == null ? '' : s)
                .replace(/&/g, '&amp;').replace(/</g, '&lt;')
                .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
        }

        function close() {
            panel.classList.add('hidden');
            panel.innerHTML = '';
            input.setAttribute('aria-expanded', 'false');
            activeIndex = -1;
        }

        function items() {
            return Array.prototype.slice.call(panel.querySelectorAll('[data-result-item]'));
        }

        function highlight(next) {
            const list = items();
            if (!list.length) return;
            if (activeIndex > -1 && list[activeIndex]) {
                list[activeIndex].classList.remove('bg-black/5');
                list[activeIndex].setAttribute('aria-selected', 'false');
            }
            activeIndex = (next + list.length) % list.length;
            list[activeIndex].classList.add('bg-black/5');
            list[activeIndex].setAttribute('aria-selected', 'true');
            list[activeIndex].scrollIntoView({ block: 'nearest' });
        }

        function render(products, query) {
            if (!products.length) {
                panel.innerHTML =
                    '<p class="px-4 py-5 text-[13px] text-black/50">No products found for &ldquo;' +
                    escapeHtml(query) + '&rdquo;</p>';
                panel.classList.remove('hidden');
                input.setAttribute('aria-expanded', 'true');
                if (status) status.textContent = 'No results';
                return;
            }

            const rows = products.map(function (p) {
                const img = thumb(p.image || (p.featured_image && p.featured_image.url));
                return '' +
                  '<a href="' + escapeHtml(p.url) + '" role="option" aria-selected="false" data-result-item' +
                     ' class="flex items-center gap-3 px-4 py-3 hover:bg-black/5 transition-colors border-b border-black/5 last:border-b-0">' +
                    (img
                      ? '<img src="' + escapeHtml(img) + '" alt="" width="44" height="60" loading="lazy" class="w-11 h-[60px] object-cover bg-black/5 shrink-0">'
                      : '<span class="w-11 h-[60px] bg-black/5 shrink-0"></span>') +
                    '<span class="min-w-0 flex-1">' +
                      '<span class="block text-[13px] truncate">' + escapeHtml(p.title) + '</span>' +
                      (p.available === false
                        ? '<span class="block text-[11px] text-black/40">Out of stock</span>'
                        : '<span class="block text-[11px] text-black/60">' + escapeHtml(formatPrice(p.price)) + '</span>') +
                    '</span>' +
                  '</a>';
            }).join('');

            const viewAll =
              '<a href="/search?q=' + encodeURIComponent(query) + '" data-result-item role="option" aria-selected="false"' +
                 ' class="block px-4 py-3 text-[12px] uppercase tracking-[.12em] text-center hover:bg-black/5 transition-colors border-t border-black/10">' +
                 'View all results</a>';

            panel.innerHTML = rows + viewAll;
            panel.classList.remove('hidden');
            input.setAttribute('aria-expanded', 'true');
            activeIndex = -1;
            if (status) status.textContent = products.length + ' results';
        }

        function search(query) {
            if (controller) controller.abort();
            controller = new AbortController();

            const url = '/search/suggest.json?q=' + encodeURIComponent(query) +
                        '&resources[type]=product&resources[limit]=' + LIMIT;

            fetch(url, { signal: controller.signal })
                .then(function (r) {
                    if (!r.ok) throw new Error('search failed');
                    return r.json();
                })
                .then(function (data) {
                    // Ignore responses that arrived after the query moved on.
                    if (query !== lastQuery) return;
                    const results = (data.resources && data.resources.results) || {};
                    render(results.products || [], query);
                })
                .catch(function (err) {
                    if (err.name === 'AbortError') return;
                    close();
                });
        }

        input.addEventListener('input', function () {
            const q = input.value.trim();
            lastQuery = q;
            clearTimeout(timer);
            if (q.length < 2) { close(); return; }
            timer = setTimeout(function () { search(q); }, DEBOUNCE_MS);
        });

        input.addEventListener('keydown', function (e) {
            const list = items();
            if (e.key === 'ArrowDown' && list.length) {
                e.preventDefault();
                highlight(activeIndex + 1);
            } else if (e.key === 'ArrowUp' && list.length) {
                e.preventDefault();
                highlight(activeIndex - 1);
            } else if (e.key === 'Enter') {
                if (activeIndex > -1 && list[activeIndex]) {
                    e.preventDefault();
                    window.location.href = list[activeIndex].getAttribute('href');
                }
            } else if (e.key === 'Escape') {
                if (!panel.classList.contains('hidden')) {
                    e.stopPropagation();
                    close();
                }
            }
        });

        // Re-open on focus if there is still a query to show.
        input.addEventListener('focus', function () {
            const q = input.value.trim();
            if (q.length >= 2 && panel.innerHTML === '') {
                lastQuery = q;
                search(q);
            }
        });

        form.addEventListener('submit', close);
    })();

    // Initialize first tab as active
    if (elements.navTabs.length > 0 && elements.tabContents.length > 0) {
        const firstTab = elements.navTabs[0];
        const firstContent = elements.tabContents[0];
        if (firstTab && firstContent) {
            firstTab.classList.add('active');
            firstContent.classList.add('active');
        }
    }

    // Handle window resize for mobile menu
    let resizeTimeout;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            if (window.innerWidth >= 768) { // md breakpoint
                if (elements.mobileMenu) {
                    elements.mobileMenu.classList.add('-translate-x-full');
                    document.body.style.overflow = '';
                }
                closeNavDropdown();
            }
        }, 100);
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-main"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Banner Slider functionality
  const sliders = document.querySelectorAll('[data-slider-id]');
  sliders.forEach(slider => {
    const sliderId = slider.dataset.sliderId;
    const slides = slider.querySelectorAll('.banner-slide');
    const prevBtn = document.querySelector(`[data-slider-prev="${sliderId}"]`);
    const nextBtn = document.querySelector(`[data-slider-next="${sliderId}"]`);
    const dots = document.querySelectorAll(`[data-slider-dot="${sliderId}"]`);
    
    let currentSlide = 0;
    const totalSlides = slides.length;
    
    function goToSlide(index) {
      currentSlide = (index + totalSlides) % totalSlides;
      slider.style.transform = `translateX(-${currentSlide * 100}%)`;
      
      // Update dots
      dots.forEach((dot, i) => {
        if (i === currentSlide) {
          dot.classList.add('!bg-white');
        } else {
          dot.classList.remove('!bg-white');
        }
      });
    }
    
    if (prevBtn) {
      prevBtn.addEventListener('click', () => goToSlide(currentSlide - 1));
    }
    
    if (nextBtn) {
      nextBtn.addEventListener('click', () => goToSlide(currentSlide + 1));
    }
    
    dots.forEach(dot => {
      dot.addEventListener('click', () => {
        const slideIndex = parseInt(dot.dataset.slideIndex);
        goToSlide(slideIndex);
      });
    });
    
    // Auto-play (optional)
    if (totalSlides > 1) {
      setInterval(() => {
        goToSlide(currentSlide + 1);
      }, 5000);
    }
  });
  
  // Product scroll functionality
  const productScrolls = document.querySelectorAll('[data-products-scroll]');
  productScrolls.forEach(productsScroll => {
    const blockId = productsScroll.dataset.productsScroll;
    const scrollLeftBtn = document.querySelector(`[data-scroll-left="${blockId}"]`);
    const scrollRightBtn = document.querySelector(`[data-scroll-right="${blockId}"]`);
    const scrollContainer = productsScroll.closest('.group\\/scroll');
    
    // Auto-scroll variables
    let autoScrollInterval;
    let isHovering = false;
    const scrollSpeed = 1; // pixels per interval
    const scrollInterval = 20; // milliseconds
    
    // Auto-scroll function
    function startAutoScroll() {
      if (autoScrollInterval) return;
      
      autoScrollInterval = setInterval(() => {
        if (!isHovering) {
          const maxScroll = productsScroll.scrollWidth - productsScroll.clientWidth;
          const currentScroll = productsScroll.scrollLeft;
          
          // Loop back to start when reaching the end
          if (currentScroll >= maxScroll - 1) {
            productsScroll.scrollLeft = 0;
          } else {
            productsScroll.scrollLeft += scrollSpeed;
          }
        }
      }, scrollInterval);
    }
    
    // Stop auto-scroll
    function stopAutoScroll() {
      if (autoScrollInterval) {
        clearInterval(autoScrollInterval);
        autoScrollInterval = null;
      }
    }
    
    // Pause on hover
    if (scrollContainer) {
      scrollContainer.addEventListener('mouseenter', () => {
        isHovering = true;
      });
      
      scrollContainer.addEventListener('mouseleave', () => {
        isHovering = false;
      });
    }
    
    // Start auto-scroll
    startAutoScroll();
    
    if (scrollLeftBtn && scrollRightBtn) {
      scrollLeftBtn.addEventListener('click', () => {
        const currentScroll = productsScroll.scrollLeft;
        
        // If at the start, loop to the end
        if (currentScroll <= 0) {
          const maxScroll = productsScroll.scrollWidth - productsScroll.clientWidth;
          productsScroll.scrollTo({ left: maxScroll, behavior: 'smooth' });
        } else {
          productsScroll.scrollBy({ left: -300, behavior: 'smooth' });
        }
      });
      
      scrollRightBtn.addEventListener('click', () => {
        const maxScroll = productsScroll.scrollWidth - productsScroll.clientWidth;
        const currentScroll = productsScroll.scrollLeft;
        
        // If near the end or will go past the end, loop to the start
        if (currentScroll >= maxScroll - 50) {
          productsScroll.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          productsScroll.scrollBy({ left: 300, behavior: 'smooth' });
        }
      });
    }

    // Drag to scroll
    let isDown = false;
    let startX;
    let scrollLeft;

    productsScroll.addEventListener('mousedown', (e) => {
      isDown = true;
      startX = e.pageX - productsScroll.offsetLeft;
      scrollLeft = productsScroll.scrollLeft;
      stopAutoScroll();
    });

    productsScroll.addEventListener('mouseleave', () => {
      isDown = false;
    });

    productsScroll.addEventListener('mouseup', () => {
      isDown = false;
      if (!autoScrollInterval) {
        startAutoScroll();
      }
    });

    productsScroll.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - productsScroll.offsetLeft;
      const walk = (x - startX);
      productsScroll.scrollLeft = scrollLeft - walk;
    });
  });
  
  // Quick Add functionality (basic - you may need to integrate with your cart system)
  const quickAddBtns = document.querySelectorAll('[data-quick-add]');
  quickAddBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const productId = btn.dataset.quickAdd;
      const productCard = btn.closest('[data-product-id]');
      const productHandle = productCard.dataset.productHandle;
      
      // Redirect to product page for now
      // You can integrate with your cart drawer here
      window.location.href = `/products/${productHandle}`;
    });
  });
  
  // Bestsellers Carousel functionality
  const bestsellersSliders = document.querySelectorAll('[data-bestsellers-slider]');
  bestsellersSliders.forEach(slider => {
    const sliderId = slider.dataset.bestsellersSlider;
    const slides = slider.children;
    const prevBtn = document.querySelector(`[data-bestsellers-prev="${sliderId}"]`);
    const nextBtn = document.querySelector(`[data-bestsellers-next="${sliderId}"]`);
    
    let currentSlide = 0;
    const totalSlides = slides.length;
    
    if (totalSlides <= 2) {
      // Hide navigation if 2 or fewer slides
      if (prevBtn) prevBtn.style.display = 'none';
      if (nextBtn) nextBtn.style.display = 'none';
      return;
    }
    
    function goToSlide(index) {
      currentSlide = (index + totalSlides) % totalSlides;
      const slideWidth = slides[0].offsetWidth;
      slider.style.transform = `translateX(-${currentSlide * slideWidth}px)`;
    }
    
    if (prevBtn) {
      prevBtn.addEventListener('click', () => goToSlide(currentSlide - 1));
    }
    
    if (nextBtn) {
      nextBtn.addEventListener('click', () => goToSlide(currentSlide + 1));
    }
    
    // Optional: Auto-play
    // setInterval(() => {
    //   goToSlide(currentSlide + 1);
    // }, 5000);
  });
  
  // Category Slider functionality
  const categorySliders = document.querySelectorAll('[data-category-slider]');
  categorySliders.forEach(slider => {
    const sliderId = slider.dataset.categorySlider;
    const slides = slider.children;
    const prevBtn = document.querySelector(`[data-category-prev="${sliderId}"]`);
    const nextBtn = document.querySelector(`[data-category-next="${sliderId}"]`);
    
    let currentSlide = 0;
    const totalSlides = slides.length;
    const slidesPerView = 4; // Show 4 categories at a time
    
    if (totalSlides <= slidesPerView) {
      // Hide navigation if not enough slides
      if (prevBtn) prevBtn.style.display = 'none';
      if (nextBtn) nextBtn.style.display = 'none';
      return;
    }
    
    function goToSlide(index) {
      const maxSlide = totalSlides - slidesPerView;
      currentSlide = Math.max(0, Math.min(index, maxSlide));
      const slideWidth = slides[0].offsetWidth;
      slider.style.transform = `translateX(-${currentSlide * slideWidth}px)`;
    }
    
    if (prevBtn) {
      prevBtn.addEventListener('click', () => goToSlide(currentSlide - 1));
    }
    
    if (nextBtn) {
      nextBtn.addEventListener('click', () => goToSlide(currentSlide + 1));
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-results"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Sort functionality
  const sortTrigger = document.querySelector('[data-sort-trigger]');
  const sortDropdown = document.querySelector('[data-sort-dropdown]');
  const sortLabel = document.querySelector('[data-sort-label]');
  const sortOptions = document.querySelectorAll('[data-sort-option]');

  // Set initial sort label based on URL parameter
  const urlParams = new URLSearchParams(window.location.search);
  const currentSort = urlParams.get('sort_by');
  if (sortLabel) {
    const selectedOption = document.querySelector(`[data-sort-option="${currentSort || 'relevance'}"]`);
    if (selectedOption) {
      sortLabel.textContent = selectedOption.textContent.trim();
      // Add underline to current sort option
      sortOptions.forEach(opt => {
        if (opt.dataset.sortOption === (currentSort || 'relevance')) {
          opt.classList.add('underline');
        } else {
          opt.classList.remove('underline');
        }
      });
    }
  }

  if (sortTrigger && sortDropdown) {
    sortTrigger.addEventListener('click', () => {
      sortDropdown.classList.toggle('hidden');
    });

    sortOptions.forEach(option => {
      option.addEventListener('click', () => {
        const value = option.getAttribute('data-sort-value');
        const label = option.textContent.trim();
        sortLabel.textContent = label;
        sortDropdown.classList.add('hidden');
        
        // Update URL with sort parameter and current search query
        const url = new URL(window.location.href);
        if (!value) {
          url.searchParams.delete('sort_by');
        } else {
          url.searchParams.set('sort_by', value);
        }
        // Keep the search query
        const searchQuery = urlParams.get('q');
        if (searchQuery) {
          url.searchParams.set('q', searchQuery);
        }
        window.location.href = url.toString();
      });
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', (e) => {
      if (!sortTrigger.contains(e.target)) {
        sortDropdown.classList.add('hidden');
      }
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
